import { useCallback, useState } from 'react';

/**
 * Modal state for custom-field conflicts during paste (same name, different type).
 */
const useCustomFieldConflict = () => {
  const [renameFieldModal, setRenameFieldModal] = useState(null);

  // Shows a modal that prompts the user to rename the conflicting field
  const onCustomFieldConflict = useCallback(({ clipboardField, existingField, existingFieldNames }) => {
    return new Promise((resolve, reject) => {
      setRenameFieldModal({
        clipboardField,
        existingField,
        existingFieldNames,
        resolve,
        reject,
      });
    });
  }, []);

  return {
    renameFieldModal,
    setRenameFieldModal,
    onCustomFieldConflict,
  };
};

export default useCustomFieldConflict;
